const swiperOne = new Swiper(".main-swiper", {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false
    },
    pagination: {
        el: ".swiper-pagination"
    }
});
const swiperTwo = new Swiper(".feedback-swiper", {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false
    },
    pagination: {
        el: ".swiper-pagination"
    }
});

//# sourceMappingURL=Ex-Moto_parcel.4e5cd6c1.js.map
